import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


import { createConfig, http } from 'wagmi'
import { coreDao } from 'wagmi/chains'
import { injected, metaMask, safe, walletConnect } from 'wagmi/connectors'

import { WagmiProvider } from 'wagmi'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'


import { Test_Bnb } from './component/Bnb_Test_Network';


const projectId = '877c463a741b5bd3313fac9778fb5b92'

//mainnet, sepolia

export const config = createConfig({
  chains: [Test_Bnb],//coreDao],//[mainnet, sepolia],
  connectors: [
    injected(),
    walletConnect({ projectId }),
    metaMask(),
    safe(),
  ],
  transports: {
    [Test_Bnb.id]: http(),
    // [coreDao.id]: http(),
    // [mainnet.id]: http(),
    // [sepolia.id]: http(),
  },
})



// export const config = createConfig({
//   chains: [Test_Bnb],//coreDao],//[mainnet, sepolia],
//   connectors: [
//     injected({
//       target() {
//         return {
//           id: 'tokenPocket',
//           name: 'TokenPocket',
//           provider: window.ethereum?.providers?.find((p) => p.isTokenPocket) || window.ethereum,
//         }
//       }
//     }),
//   ],
//   transports: {
//     [Test_Bnb.id]: http(),
//     // [coreDao.id]: http(),
//     // [mainnet.id]: http(),
//     // [sepolia.id]: http(),
//   },
// })


// export const config = createConfig({
//   chains: [Test_Bnb],
//   connectors: [
//     injected({
//       // We use a function that safely looks up TokenPocket at the moment of connection
//       target() {
//         if (typeof window === 'undefined') return undefined

//         // Find TokenPocket specifically among injected providers
//         const tokenPocketProvider = window.ethereum?.providers?.find((p) => p.isTokenPocket) 
//           || (window.ethereum?.isTokenPocket ? window.ethereum : undefined)

//         return {
//           id: 'tokenPocket',
//           name: 'TokenPocket',
//           provider: tokenPocketProvider,
//         }
//       }
//     }),
//   ],
//   transports: {
//     [Test_Bnb.id]: http(),
//   },
// })


// export const config = createConfig({
//   chains: [Test_Bnb],
//   connectors: [
//     // This explicitly instructs Wagmi to grab TokenPocket's EIP-6963 flag
//     injected({ target: 'tokenPocket' }) 
//   ],
//   transports: {
//     [Test_Bnb.id]: http(),
//   },
// })


// export const config = createConfig({
//   chains: [Test_Bnb],
//   connectors: [
//     injected({
//       target() {
//         return {
//           id: 'tokenPocket',
//           name: 'TokenPocket',
//           get provider() {
//             if (typeof window === 'undefined') return undefined;

//             // Look inside the multi-provider array populated by extensions
//             const providers = (window.ethereum as any)?.providers;
//             if (Array.isArray(providers)) {
//               const tp = providers.find((p) => p.isTokenPocket);
//               if (tp) return tp;
//             }

//             // Fallback to checking the base window flag directly
//             if ((window.ethereum as any)?.isTokenPocket) {
//               return window.ethereum;
//             }

//             return undefined;
//           },
//         };
//       },
//     }),
//   ],
//   transports: {
//     [Test_Bnb.id]: http(),
//   },
// })

const queryClient = new QueryClient()


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <WagmiProvider config={config}>
      {/* <React.StrictMode> */}
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
    {/* </React.StrictMode> */}
  </WagmiProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
